import React, { useEffect, useState } from 'react';

import loadingImg from '../../asset/img/common/loading.gif';

const ModalOverLay = {
  boxSizing: 'border-box',
  position: 'fixed',
  top: '0',
  left: '0',
  bottom: '0',
  right: '0',
  zIndex: '2000',
  margin: '0 auto',
  // background: '#fff',
};

const loadingStyled = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const Loading = ({ open, setOpen, ...rest }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    // <Fade duration={1300}>
    visible && ( // visible이 true일 때만 렌더링
      <div style={ModalOverLay}>
        <img src={loadingImg} style={loadingStyled} width="120px" height="120px" />
      </div>
    )
    // </Fade>
  );
};

export default Loading;
